import React, { useEffect, useState, useRef } from 'react'

import {
    Box,
    Container,
    styled,
    Card,
    Link
} from '@mui/material';

import { useNavigate } from 'react-router-dom';

import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import CommonRestricted from '../../common/CommonRestricted';

// import DataGridRowActionMenu from '../../common/DataGridRowActionMenu';
import DataGridTable from '../../common/DataGridTable';
import DataGridToolbar from '../../common/DataGridToolbar';

import { icons } from '../../common/CommonIcons';
import { useSystemPrompt } from '../../../hooks/useSystemPrompt';
import { useDocuments, documentTypes, targetTypes } from '../../../hooks/api/useDocuments';
import { useDataGridParams } from '../../../hooks/useDataGridParams';
import { useAppContextFeatures } from '../../../context/AppContext';
import { useSystemRoutes, routeTypes } from '../../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../hooks/usePermissions';
import { useTranslations } from '../../../hooks/useTranslations';
import { useDependencies, dependencyModules, targetTypes as dependencyTargetTypes } from '../../../hooks/api/useDependencies';

const StyledCard = styled(Card)(({ theme }) => ({
    // padding: theme.spacing(4)
}));

export default function ListRetailPrescriptions({
    routeType
}) {
    const { t } = useTranslations({ ns: ["common", "@document"] })

    const navigate = useNavigate();

    const { promptMessage } = useSystemPrompt();
    const { list, remove } = useDocuments({ documentType: documentTypes.retailPrescription });
    const { defineColumns, columns, filterValues, getRenderColumnLink, getRenderColumnDateDisplay, getRenderColumnTextDisplay } = useDataGridParams('id')
    const { RenderDatagridDisplay: RenderDependencyDatagridDisplay } = useDependencies()

    const [selectedIds, setSelectedIds] = useState([])
    const [refreshDataGrid, setRefreshDataGrid] = useState(0)
    const { getLocationIds } = useAppContextFeatures();
    const { getRoute } = useSystemRoutes(routeType)
    const { getHtmlHead } = useSystemHead(routeType)
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.document.id, scopeTypes.document.retailPrescription.id)

    const gridRef = useRef();

    const fetchData = async (props) => {

        resetDataGridTableSelection();

        try {
            props.dataTypes = ["dependency"]

            // const result = await list({ ...props, customFilterLocationEnable: true, customFilterLocationField: 'location_id' })
            props.customFilterLocationEnable = true;
            props.customFilterLocationFields = ['location_id']

            const result = await list(props)

            let rawData = result?.data?.documents

            let newData = []
            
            rawData.forEach(i => {

                let _i = i

                let outward = _i?.outward_dependencies
                let inward = _i?.inward_dependencies

                let all = [...outward, ...inward]

                // declare a value and allocate the combined data
                _i.all_dependencies = all

                newData.push(_i)
            })

            return {
                data: newData,
                count: result?.data?.nofilter_total
            }

        } catch (error) {

            promptMessage(false, `Error getting results (${error?.message})`)

            return {
                data: [],
                count: 0
            }
        }

    }

    useEffect(() => {

        setRefreshDataGrid(val => val + 1)

    }, [getLocationIds])


    useEffect(() => {

        defineColumnsView()

    }, [])

    const defineColumnsView = () => {
        defineColumns([
            {
                name: "location_name",
                header: t("location"),
            },
            {
                name: "doc_number",
                header: t("docNo"),
                renderValue: ({ cellProps, value }) => {

                    if (isPermissionAllow({ functionType: functionTypes.pageView.id }) === false) {
                        return getRenderColumnTextDisplay(value)
                    }

                    let path = getRoute(`documents/retailPrescription/view/${cellProps.data.id}`);

                    return getRenderColumnLink(path, value)

                }
            },
            {
                name: "doc_date",
                header: t("docDate"),
                renderValue: ({ cellProps, value }) => getRenderColumnDateDisplay(value)
            },
            {
                name: "profile_name",
                header: t("profile"),
            },
            {
                name: 'all_dependencies', 
                header: t('relatedDocs'),
                renderValue: ({ value, cellProps }) => {

                    return (
                        <RenderDependencyDatagridDisplay
                            id={cellProps.data.id}
                            values={value}
                            renderValue={({ id, otherUrl }) => {

                                if(otherUrl){
                                    return getRoute(otherUrl)
                                }
    
                                return getRoute(`documents/retailPrescription/view/${id}`)
                            }}
                        />
                    )

                }

            },
            // {
            //     name: "billing_profile_name",
            //     header: "Billing",
            // },
            // {
            //     name: "delivery_profile_name",
            //     header: "Delivery",
            // }
        ])
    }

    const resetDataGridTableSelection = () => {
        setSelectedIds([])
    }

    const handleDelete = async () => {

        try {
            const result = await remove({ ids: selectedIds })

            promptMessage(true, result?.message)
            setRefreshDataGrid(val => val + 1)

            resetDataGridTableSelection();

        } catch (error) {
            promptMessage(false, error?.message)
        }

    }

    const RenderToolbar = () => {

        const getToolbarMainMenus = () => {

            let props = [];

            if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
                props.push({
                    displayIconName: icons.plus,
                    onClick: () => {

                        navigate(getRoute("documents/retailPrescription/new"));

                    }
                })
            }

            return props
        }

        const getActionOnClick = () => {

            let handleFunction = null

            if (isPermissionAllow({ functionType: functionTypes.remove.id })) {
                handleFunction = handleDelete
            }

            return handleFunction
        }

        return (
            <DataGridToolbar
                selectedRowCount={
                    selectedIds.length
                }
                mainMenus={
                    getToolbarMainMenus()
                }
                actionOnClickRemove={
                    getActionOnClick()
                }
                actionMenus={[]}
            />
        )
    }

    const RenderDataGridTable = () => {

        return (
            <DataGridTable
                ref={gridRef}
                refresh={refreshDataGrid}
                fetchData={fetchData}
                dataGrid={{
                    idProperty: "id",
                    style: {
                        // minHeight: 600
                    },
                    // pageSizes: [20, 50, 100],
                    // defaultLimit: 10,
                    // defaultSkip: 0,
                    checkboxColumn:
                        isPermissionAllow({ functionType: functionTypes.remove.id }),
                    columns,
                    defaultFilterValue: filterValues,
                    onSelectionChange: (items) => {
                        // console.log('items selected : ', items)
                        setSelectedIds(
                            items
                        )
                    }
                }}

            />
        )

    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.retailPrescriptions })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("retailPrescriptions")}
                breadcrumbs={[
                    {
                        displayText: t("retailPrescriptions"),
                        props: {
                            // underline: "hover",
                            // href: "/"
                        }
                    }
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageList.id }) ?
                    <>
                        {
                            RenderToolbar()
                        }
                        {
                            RenderDataGridTable()
                        }
                    </>
                    :
                    (
                        <CommonRestricted />
                    )
            }

        </Box>
    )
}
